const defaultConfirmationOptions = {
  hideHeaderClose: false,
  size: 'sm',
  okVariant: 'success',
  okTitle: 'YES, I FINISHED IT ',
  cancelTitle: 'NOT YET',
  footerClass: 'p-2',
  centered: true,
};

const defaultOptions = {
  title: 'Title default',
  size: 'sm',
  buttonSize: 'sm',
  headerClass: 'p-2 border-bottom-0',
  footerClass: 'p-2 border-top-0',
  centered: true,
};

const modalsMixin = {
  methods: {
    confirmationModal(message = '', options = defaultConfirmationOptions) {
      return this.$bvModal.msgBoxConfirm(message, { ...defaultConfirmationOptions, ...options });
    },
    notificationOkModal(message = '', options = defaultOptions) {
      return this.$bvModal.msgBoxOk(message, {...defaultOptions, ...options});
    },
  },
};

export { modalsMixin };
